import React from 'react'
import { Link } from 'react-router-dom'

// CSS
import '../css/breadcrumb.css'

export default function Breadcrumb({structure}) {
	if(!structure){
		return null;
	}

	return (
		<React.Fragment>
			<ul className="breadcrumb">
				{structure && structure.map((crumb, i) => {
					return <li key={i}><Link to={`/category/${crumb.permalink}`}>{crumb.title}</Link></li>
				})}
			</ul>
		</React.Fragment>
	)
}



// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js